import { isUndefined, noop } from 'lodash';
import { useTranslation } from 'react-i18next';
import { AssignmentPreviewWarningBanner } from 'domains/assignments/Components/AssignmentPreviewBanner';
import DailyRoutine from 'domains/dailyRoutines/Page';
import { useNavigation } from 'utils/hooks/useNavigation';

export const PreviewADL = (): JSX.Element | null => {
  const { t } = useTranslation();
  const { params } = useNavigation();

  const { learningPathId, adlId } = params;
  if (isUndefined(learningPathId) || isUndefined(adlId)) {
    throw new Error(t('notFound.pageTitle'));
  }

  return (
    <>
      <AssignmentPreviewWarningBanner />
      <div className="mb-128">
        <DailyRoutine learningPathId={learningPathId} dailyRoutineId={adlId} onSubmit={noop} previewMode />
      </div>
    </>
  );
};
